// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1UuOH","label":"CategoryService_label__2V7gq","location":"CategoryService_location__cjfOE"};